import homeReducer from "./reducers";

export default homeReducer